import { render, staticRenderFns } from "./LpuNotWorkingLabel.vue?vue&type=template&id=515cae96&"
import script from "./LpuNotWorkingLabel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuNotWorkingLabel.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515cae96')) {
      api.createRecord('515cae96', component.options)
    } else {
      api.reload('515cae96', component.options)
    }
    module.hot.accept("./LpuNotWorkingLabel.vue?vue&type=template&id=515cae96&", function () {
      api.rerender('515cae96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuNotWorkingLabel/LpuNotWorkingLabel.vue"
export default component.exports